/**
 * Component to manage our  Return Reasons Languages
 *
 * @component
 */

import React, { Component } from 'react'
import {
  Modal,
  Button,
  Divider,
  message,
  Col,
  Row,
  Checkbox,
  Input,
} from 'antd'
import axios from 'axios'
import { trackingVitally } from '../../../../../helpers/vitally'

class ReturnNoteCusomize extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      customizeNote: {
        isRequire: false,
        title: '',
      },
      customizeNoteDisabled: false,
    }
  }

  getReturnSetting = async () => {
    try {
      const response = await axios.get('/api/returnSettings')
      if (response?.data) {
        const defaultCustomize = this.state.customizeNote
        this.setState({
          customizeNote: this.props.isWarrantySettings ? {
            ...defaultCustomize,
            ...response.data.warrantyCustomizeNotes,
          } : {
            ...defaultCustomize,
            ...response.data.customizeNote,
          },
          customizeNoteDisabled: response.data.customizeNoteDisabled || false,
        })
      }
    } catch (err) {
      return message.error('Something went wrong please try again', 5)
    }
  }

  onChangeRequire = (e) => {
    const customizeNote = {
      ...this.state.customizeNote,
      isRequire: e.target.checked,
    }
    this.setState({
      customizeNote: customizeNote,
    })
  }

  onChangeDisabled = (e) => {
    this.setState({
      customizeNoteDisabled: e.target.checked,
    })
  }

  onChangeTitle = (e) => {
    const customizeNote = {
      ...this.state.customizeNote,
      title: e.target.value,
    }
    this.setState({
      customizeNote: customizeNote,
    })
  }

  onSave = async () => {
    const payload = {
      customizeNoteDisabled: this.state.customizeNoteDisabled
    }
    if (this.props.isWarrantySettings) {
      payload.warrantyCustomizeNotes = this.state.customizeNote
    } else {
      payload.customizeNote = this.state.customizeNote
    }
    try {
      await axios.post(`/api/returnSettings/updateCustomizeQuery`, payload);
      trackingVitally('rr_customerjourney_edited');
      message.success('Saved successfully', 5)
    } catch (e) {
      return message.error('Something went wrong please try again', 5)
    }
  }

  componentDidMount = async () => {
    this.getReturnSetting()
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          width={this.props.featureMultilangReturnReasons ? 1100 : 720}
          title="Customize customer note"
          visible={this.props.visible}
          // onOk={this.props.onOk}
          onCancel={this.props.onCancel}
          footer={null}
        >
          <Row>
            <Col>
              <Checkbox
                checked={this.state.customizeNoteDisabled}
                onChange={this.onChangeDisabled}
                defaultValue={false}
                data-intercom-target="disable-customer-notes-checkbox-configuration-returns"
              >
                Disable customer notes field
              </Checkbox>
            </Col>
          </Row>
          <Row className="u-marginTop--md">
            <Col>
              <Checkbox
                checked={this.state?.customizeNote?.isRequire}
                onChange={this.onChangeRequire}
                defaultValue={true}
                disabled={this.state.customizeNoteDisabled}
                data-intercom-target="require-customer-notes-checkbox-configuration-returns"
              >Require your customer to fill out the notes field.</Checkbox>
            </Col>
          </Row>
          <Row className="u-marginTop--md">
            <p>Change the title of the field</p>
          </Row>
          <Row>
            <Input
              value={this.state?.customizeNote?.title}
              onChange={this.onChangeTitle}
              disabled={this.state.customizeNoteDisabled}
              data-intercom-target="title-customer-notes-input-configuration-returns"
            />
          </Row>
          <Row span={24} type="flex" justify="end" className="u-marginTop--md">
            <Button type="primary" onClick={this.onSave}>
              Save changes
            </Button>
          </Row>
        </Modal>
      </React.Fragment>
    )
  }
}

export default ReturnNoteCusomize
